import CryptoAES from "crypto-js/aes";
import CryptoENC from "crypto-js/enc-utf8";

export default function UseEncryption(data) {
  const bytes = CryptoAES.decrypt(data, process.env.REACT_APP_SECRET_KEY);
  return JSON.parse(bytes.toString(CryptoENC));
}
